// extracted by mini-css-extract-plugin
module.exports = {"content":"e_Fr","opened":"e_Gr","buttonIcon":"e_Hr","buttonIconOpen":"e_Ir","toggle":"e_Jr","collapsible":"e_Kr"};